module.exports = __webpack_public_path__ + "img/b45cff2.jpg";